<template>
  <div style="width: 100%;">
    <h3>{{$t('field.productTypeSelect')}}</h3>
      <div v-if="!onlyTable">
        <el-row>
          <el-col :span="16">
            <el-form-item :label="$t('field.productType')" label-width="200px">  
              <el-select v-model="productType" :placeholder="$t('msg.pleaseSelect')" class="selectStyle" >
                <el-option v-for="item in productTypeOpts"  :key="item"  :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>   
        <!-- productType = detector -->
        <div v-if="productType == productTypeOpts[0]">
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.detectorType')" label-width="200px">
               <el-select v-model="detector.model" :placeholder="$t('msg.pleaseSelect')" class="selectStyle" clearable >
                  <el-option v-for="item in detector.modelOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>            
              </el-form-item>
            </el-col>  
            <el-col :span="12">
              <el-form-item :label="$t('field.detectorOdmType')" label-width="200px">
                 <el-select v-model="detector.odm" :placeholder="$t('msg.pleaseSelect')" class="selectStyle" clearable >
                  <el-option v-for="item in detector.odmOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.detectorInnocareSn')" label-width="200px">
                <el-select v-model="detector.sn" filterable allow-create :placeholder="$t('msg.pleaseSelect')"  @change="changeDetectorSn()" clearable class="selectStyle">
                  <el-option v-for="item in detector.snOpts" :key="item.serialNo" :label="item.serialNo" :value="item.serialNo"></el-option>
                </el-select>               
              </el-form-item>
            </el-col>  
            <el-col :span="12">
              <el-form-item :label="$t('field.detectorOdmSn')" label-width="200px">
                <el-select v-model="detector.odmSn" filterable allow-create :placeholder="$t('msg.pleaseSelect')"  @change="changeDetectorSn()" clearable class="selectStyle">
                  <el-option v-for="item in detector.odmSnOpts" :key="item.serialNo" :label="item.serialNo" :value="item.serialNo"></el-option>
                </el-select>               
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>            
            <el-col :span="12">
              <el-form-item :label="$t('field.sdkVersion')" label-width="200px">
                <el-select v-model="detector.sdk" :placeholder="$t('msg.pleaseSelect')" class="selectStyle" filterable allow-create clearable>
                  <el-option-group v-for="group in detector.sdkOpts" :key="group.label" :label="group.label">    
                    <el-option v-for="item in group.options" :key="item.value" :label="item.label"  :value="item.value">
                    </el-option>
                  </el-option-group> 
                </el-select>

              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.installedTime')" required label-width="200px">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="detector.installDate" ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.issueOccurrenceDate')" required label-width="200px">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="detector.issueDate" ></el-date-picker>
              </el-form-item>
            </el-col>  
          </el-row> 
        </div>
        <!-- productType = accessory -->
        <div v-if="this.productType == this.productTypeOpts[1]">
          
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.accessoryType')" label-width="200px">
                <el-select v-model="accessory.model" :placeholder="$t('msg.pleaseSelect')" clearable class="selectStyle">
                  <el-option v-for="item in accessory.modelOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>            
              </el-form-item>
            </el-col>  
            <el-col :span="12">
              <el-form-item :label="$t('field.accessoryOdmType')" label-width="200px">
                <el-select v-model="accessory.odm" :placeholder="$t('msg.pleaseSelect')"  clearable class="selectStyle">
                  <el-option v-for="item in accessory.odmOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.serialNo')" label-width="200px">
                <el-select v-model="accessory.sn" filterable allow-create :placeholder="$t('msg.pleaseSelect')"  @change="changeAccessorySn()" clearable class="selectStyle">
                  <el-option v-for="item in accessory.snOpts" :key="item.serialNo" :label="item.serialNo" :value="item.serialNo"></el-option>
                </el-select>               
              </el-form-item>
            </el-col>  
            <el-col :span="12">
              <el-form-item :label="$t('field.detectorOdmSn')" label-width="200px">
                <el-select v-model="accessory.odmSn" filterable allow-create :placeholder="$t('msg.pleaseSelect')"  @change="changeAccessorySn()" clearable class="selectStyle">
                  <el-option v-for="item in accessory.odmSnOpts" :key="item.serialNo" :label="item.serialNo" :value="item.serialNo"></el-option>
                </el-select>               
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.installedTime')" required label-width="200px">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="accessory.installDate" ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.issueOccurrenceDate')" required label-width="200px">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="accessory.issueDate" ></el-date-picker>
              </el-form-item>
            </el-col>  
          </el-row> 
        </div>
        <!-- productType = software -->
        <div v-if="productType == productTypeOpts[2]">
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.softwareType')" required label-width="200px" >               
                <el-select v-model="software.model" :placeholder="$t('msg.pleaseSelect')" class="selectStyle" >
                  <el-option v-for="item in software.modelOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.version')" required label-width="200px">               
                <el-select v-model="software.version" :placeholder="$t('msg.pleaseSelect')" class="selectStyle">
                  <el-option v-for="item in software.versionOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
                </el-col>
          </el-row>
          <el-row>        
            <el-col :span="12">
              <el-form-item :label="$t('field.issueOccurrenceDate')" required label-width="200px">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="software.issueDate" ></el-date-picker>
              </el-form-item>
            </el-col>  
            <el-col :span="12">
              <el-form-item :label="$t('field.demoProblem')" label-width="350px" required>
                <el-radio-group v-model="software.canDemo">
                  <el-radio :label="$t('field.yes')"></el-radio>
                  <el-radio :label="$t('field.no')"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>        
          </el-row> 
         
          
        </div>        
        <!-- productType = semi -->
        <div v-if="productType == productTypeOpts[3]">
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.customerType')" label-width="200px">               
                <el-select v-model="semi.custType" :placeholder="$t('msg.pleaseSelect')" clearable class="selectStyle" filterable allow-create>
                  <el-option v-for="item in semi.custTypeOpts"  :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.incxType')" label-width="200px">               
                <el-select v-model="semi.incxType" :placeholder="$t('msg.pleaseSelect')" clearable class="selectStyle" filterable allow-create>
                  <el-option v-for="item in semi.incxTypeOpts" :key="item.value"  :label="item.value" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
                </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.glassID')" required label-width="200px">
                <el-input v-model="semi.glassId" maxlength=36 class="selectStyle"></el-input>
              </el-form-item>
            </el-col> 
            <!--
            <el-col :span="12">
              <el-form-item :label="$t('field.deliveryDate')" required label-width="200px">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="semi.deliveryDate"></el-date-picker>
              </el-form-item>
            </el-col>-->
          </el-row>
        </div>
        <el-col :span="24" style="text-align: center;padding-bottom: 10px;">
          <el-button type="success" @click="addProductType"  size="small">{{$t('button.create')}}</el-button>
        </el-col>
      </div>  
      <el-table ref="singleTable" :data="productTypeTable.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')" width:1000px>
        <el-table-column v-for="(v, i) in productTypeTable.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
          <template slot-scope="scope">          
            <span>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('action')" v-if="!onlyTable">
          <template slot-scope="scope">    
            <el-button type="danger" @click="delTableData(scope.row, scope.$index, true)">{{$t('button.delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
  </div>
</template>

<script>
import {apiFindProductSelectedListByUserAttr, apiFindSwfwByVersionTypeAndName,apiFindFeedbackProductTypeByFeedbackId,apiFindSnForFeedbackProductType,
        apiFindOdmSnForFeedbackProductType, apiFindFirmwareVersion } from "../../../utils/api.js";
import authHeader from "../../../services/auth-header";
import CommonUtil from "../../../utils/commonUtil.js";


export default {
  props: {    
    custNo: {
      type: String
    },
    onlyTable: {
      type: Boolean,
      Default: false
    },
    pFeedbackId: {
      type: String
    },
 
  },
  data() {   
    return { 
      productType:'',
      productTypeOpts:['Detector 探測器','Accessory 配件','Software 軟體','Semi-finished Product 半成品'],
      detector:{
        model:'',
        odm:'',
        sn:'',
        odmSn:'',
        sdk:'',
        installDate:'',
        issueDate:'',
        modelOpts:[],
        odmOpts:[],
        sdkOpts:[],
        snOpts:[],
        odmSnOpts:[],
        snOriOpts:[]
      },
      accessory:{
        model:'',
        odm:'',
        sn:'',
        odmSn:'',
        installDate:'',
        issueDate:'',
        modelOpts:[],
        odmOpts:[],
        snOpts:[],    
        odmSnOpts:[],
        snOriOpts:[]
      },
      software:{
        model:'',
        version:'',
        canDemo:'',
        installDate:'',
        issueDate:'',
        modelOpts:[],
        versionOpts:[]
      },    
      semi:{
        custType:'',
        incxType:'',
        glassId:'',
        deliveryDate:'',
        custTypeOpts:[],
        incxTypeOpts:[]
      }, 
      productTypeTable:{
        columns: [
          { field: "productType", title: this.$i18n.t('field.productType'), width: 120 },         
          { field: "mainType", title: this.$i18n.t('field.mainType') , width: 180  },
          // { field: "subType", title: this.$i18n.t('field.subType'), width: 200  },
          { field: "sn", title:this.$i18n.t('field.serialNo')+' / Glass ID', width: 160 },
          { field: "version", title: this.$i18n.t('field.version'), width: 150  },
          { field: "date1", title: this.$i18n.t('field.installedTime')+ ' / '+ this.$i18n.t('field.deliveryDate'), width: 180 },
          { field: "date2", title: this.$i18n.t('field.issueOccurrenceDate'), width: 180 },
          { field: "canDemo", title: this.$i18n.t('field.demoProblem') }
        ],
        data: []
      },
      rules: {          
      
      }
    };
  },
  watch: { 
    productType () {

      if(this.productType == this.productTypeOpts[0]){
        this.detector.modelOpts=[];
        this.detector.odmOpts=[];
        this.detector.sdkOpts=[];

        apiFindProductSelectedListByUserAttr({ headers: authHeader(), custSapCode: this.custNo, attribute:'DETECTOR_INNOCARE_MODEL'}).then((response) => {           
          response.data.forEach((item, index) => {   
            this.detector.modelOpts.push({ value: item.value, label: item.value });
          });
          
        }).catch((err) => { console.log(err); });

        apiFindProductSelectedListByUserAttr({ headers: authHeader(), custSapCode: this.custNo, attribute:'DETECTOR_ODM_MODEL'}).then((response) => {           
          response.data.forEach((item, index) => {   
            this.detector.odmOpts.push({ value: item.value, label: item.value });
          });
        }).catch((err) => { console.log(err); });

        apiFindFirmwareVersion({ headers: authHeader()}).then((response) => {    
          // response.data.forEach((item, index) => {   
          //   this.detector.sdkOpts.push({ value: item, label: item });
          // });
          CommonUtil.setGroupSelectItem(response.data, this.detector.sdkOpts)
        }).catch((err) => { console.log(err); });

        apiFindSnForFeedbackProductType({ headers: authHeader(),custNo:this.custNo}).then((response) => {           
          
          // response.data.forEach((item, index) => {   
            // if(item.installDate != null && item.installDate!= ''){
            //   let date = CommonUtil.dateFormatDate(new Date(item.installDate));
            //   this.detector.snOpts.push({ value: item.serialNo, label: item.serialNo+'('+date+')' });
            // }else{
              // this.detector.snOpts.push({ value: item.serialNo, label: item.serialNo });
            // }
            
          // });
          this.detector.snOpts = response.data;
          this.detector.snOriOpts = response.data;
        }).catch((err) => { console.log(err); });


        apiFindOdmSnForFeedbackProductType({ headers: authHeader(),custNo:this.custNo}).then((response) => {                       
          this.detector.odmSnOpts = response.data;
        }).catch((err) => { console.log(err); });

      }else if(this.productType == this.productTypeOpts[1]){
        this.accessory.modelOpts=[];
        this.accessory.odmOpts=[];
        apiFindProductSelectedListByUserAttr({ headers: authHeader(), custSapCode: this.custNo, attribute:'ACCESSORY_INNOCARE_MODEL'}).then((response) => {           
          response.data.forEach((item, index) => {   
            this.accessory.modelOpts.push({ value: item.value, label: item.value });
          });
        }).catch((err) => { console.log(err); });

        apiFindProductSelectedListByUserAttr({ headers: authHeader(), custSapCode: this.custNo, attribute:'ACCESSORY_ODM_MODEL'}).then((response) => {           
          response.data.forEach((item, index) => {   
            this.accessory.odmOpts.push({ value: item.value, label: item.value });
          });
        }).catch((err) => { console.log(err); });

        apiFindSnForFeedbackProductType({ headers: authHeader(),custNo:this.custNo}).then((response) => {      
          this.accessory.snOpts = response.data;
          this.accessory.snOriOpts = response.data;
        }).catch((err) => { console.log(err); });
        
        apiFindOdmSnForFeedbackProductType({ headers: authHeader(),custNo:this.custNo}).then((response) => {                
          this.accessory.odmSnOpts = response.data;
        }).catch((err) => { console.log(err); });

      }else if(this.productType == this.productTypeOpts[2]){
        this.software.modelOpts=[];     
        this.software.versionOpts=[];     
        this.software.version='';
        apiFindProductSelectedListByUserAttr({ headers: authHeader(), custSapCode: this.custNo, attribute:'SOFTWARE_INNOCARE;SOFTWARE_ODM'}).then((response) => {          
          response.data.forEach((item, index) => {
            this.software.modelOpts.push({ value: item.value, label: item.value });
          });
        }).catch((err) => { console.log(err); });

      }else if(this.productType == this.productTypeOpts[3]){
        this.semi.custTypeOpts=[];
        this.semi.incxTypeOpts=[];
        apiFindProductSelectedListByUserAttr({ headers: authHeader(), custSapCode: this.custNo, attribute:'SEMI_CUSTOMER_MODEL'}).then((response) => {           
          response.data.forEach((item, index) => {   
            this.semi.custTypeOpts.push({ value: item.value, label: item.value });
          });
        }).catch((err) => { console.log(err); });
        apiFindProductSelectedListByUserAttr({ headers: authHeader(), custSapCode: this.custNo, attribute:'SEMI_INCX_MODEL'}).then((response) => {           
          response.data.forEach((item, index) => {   
            this.semi.incxTypeOpts.push({ value: item.value, label: item.value });
          });
        }).catch((err) => { console.log(err); });

      }


    },
    "software.model"(){
      this.software.versionOpts=[];     
      this.software.versionOpts=[];     
      this.software.version=''; 
      
      apiFindSwfwByVersionTypeAndName({ headers: authHeader(), versionType:"Official ver.", name : this.software.model}).then((response) => {           
        response.data.forEach((item, index) => {   
          this.software.versionOpts.push({ value: item, label: item });
        });
      }).catch((err) => { console.log(err); });
    },
    "productTypeTable.data"(){
      this.$emit('updateProductTypeData', this.productTypeTable.data); 

    }
  },
  mounted() {
    if(this.pFeedbackId != null && this.pFeedbackId != ''){ 
      apiFindFeedbackProductTypeByFeedbackId({ headers: authHeader(), feedbackId: this.pFeedbackId}).then((response) => {           
          if(response.data != null){
            response.data.forEach( function ( item, index, array)  {    
              if(item.date1 != null && item.date1 != ''){
                item.date1 = CommonUtil.dateFormatDate(new Date(item.date1));
              }
              if(item.date2 != null && item.date2 != ''){
                item.date2 = CommonUtil.dateFormatDate(new Date(item.date2));
              }
            });
            this.productTypeTable.data = response.data;
          }
          
        }).catch((err) => { console.log(err); });

    }
  },
  methods: {
    delTableData(row, index){  
      this.productTypeTable.data.splice(index, 1);
    },
    addProductType(){
      var type = this.productType;
      if(type == ''){
        this.$message({ type: "warning", message: this.$i18n.t('field.productType') +' '+ this.$i18n.t('msg.fieldNotEmpty'), duration: 1000});
      } else {
        var isDuplicate = this.isDuplicate(type);        
        if(isDuplicate){
          this.$message({ type: "error", message: this.$i18n.t('msg.isDuplicateCannotAdd'), duration: 1000});
        }else{
          this.createProductTypeRow(type);
        }
      }
    },
    isDuplicate(type){
      let isDuplicate = false;
      this.productTypeTable.data.forEach((item, index) => {   
        var a = this.productTypeOpts[0];    
        if(type == this.productTypeOpts[0] && item.productType == type){       
          if((item.mainType == this.detector.model || item.mainType == this.detector.odm) && 
            (item.sn == this.detector.sn || item.odmSn == this.detector.odmSn) && item.version == this.detector.sdk && 
            item.date1 == this.detector.installDate && item.date2 == this.detector.issueDate ){
              isDuplicate = true;
          }
        } else if(type == this.productTypeOpts[1]  && item.productType == type){
          if((item.mainType == this.accessory.model || item.mainType == this.accessory.odm) && 
            item.sn == this.accessory.sn && item.date1 == this.accessory.installDate && 
            item.date2 == this.accessory.issueDate ){
              isDuplicate = true;
          }
        } else if(type == this.productTypeOpts[2]  && item.productType == type){
          if((item.mainType == this.software.model || item.mainType == this.software.version)  && 
             item.date2 == this.software.issueDate && item.canDemo == this.software.canDemo ){
              isDuplicate = true;
          }
        } else if(type == this.productTypeOpts[3]  && item.productType == type){
          if((item.mainType == this.semi.custType || item.mainType == this.semi.incxType) && 
            item.sn == this.semi.glassId ){
              isDuplicate = true;
          }
        }
      });
      return isDuplicate;
    },
    createProductTypeRow(type){
      let mainType = '', sn = '', version = '', date1 = '', date2 = '', canDemo = '';

      if(type == this.productTypeOpts[0] ){        
        if((CommonUtil.isNull(this.detector.model) && CommonUtil.isNull(this.detector.odm)) || 
           (CommonUtil.isNull(this.detector.sn) && CommonUtil.isNull(this.detector.odmSn)) || 
           CommonUtil.isNull(this.detector.installDate)|| CommonUtil.isNull(this.detector.issueDate) ){
          this.$message({ type: "warning", message: this.$i18n.t('msg.incompleteInfo'), duration: 1000});
          return;
        }else if(!CommonUtil.isNull(this.detector.model) && !CommonUtil.isNull(this.detector.odm)){ 
          this.$message({ type: "warning", message: this.$i18n.t('msg.productTypeDetectorOnlyChooseOne'), duration: 1000});
          return;
        }
        if(CommonUtil.isNull(this.detector.model)){
          mainType = this.detector.odm; 
        }else{
          mainType = this.detector.model; 
        }

        if(CommonUtil.isNull(this.detector.model)){
          sn = this.detector.odmSn;
        }else{
           sn = this.detector.sn;
        }

        version = this.detector.sdk;
        date1 = this.detector.installDate;
        date2 = this.detector.issueDate;
    
        this.detector.model = ''; 
        this.detector.odm = ''; 
        this.detector.sn = ''; 
        this.detector.sdk = ''; 
        this.detector.installDate = ''; 
        this.detector.issueDate = ''; 
        this.detector.snOpts=[];
        this.detector.snOriOpts=[];
        this.detector.modelOpts=[];
        this.detector.odmOpts=[];
      } else if(type == this.productTypeOpts[1] ){     
        if( (CommonUtil.isNull(this.accessory.model) && CommonUtil.isNull(this.accessory.odm)) ||
            (CommonUtil.isNull(this.accessory.sn) && CommonUtil.isNull(this.accessory.odmSn)) ||
             CommonUtil.isNull(this.accessory.installDate) || CommonUtil.isNull(this.accessory.issueDate) ){
          this.$message({ type: "warning", message: this.$i18n.t('msg.incompleteInfo'), duration: 1000});
          return;
        }else if(!CommonUtil.isNull(this.accessory.model) && !CommonUtil.isNull(this.accessory.odm)){ 
          this.$message({ type: "warning", message: this.$i18n.t('msg.productTypeAccessoryTypeOnlyChooseOne'), duration: 1000});
          return;
        }
        if(CommonUtil.isNull(this.accessory.model)){
          mainType = this.accessory.odm; 
        }else{
          mainType = this.accessory.model; 
        }
        if(CommonUtil.isNull(this.accessory.model)){
          sn = this.accessory.odmSn;
        }else{
          sn = this.accessory.sn;
        }
        date1 = this.accessory.installDate;
        date2 = this.accessory.issueDate;
 
        this.accessory.model = ''; 
        this.accessory.odm = ''; 
        this.accessory.sn = ''; 
        this.accessory.installDate = ''; 
        this.accessory.issueDate = ''; 
        this.accessory.snOpts=[];
        this.accessory.snOriOpts=[];
        this.accessory.modelOpts=[];
        this.accessory.odmOpts=[];
      } else if(type == this.productTypeOpts[2] ){        
        if( CommonUtil.isNull(this.software.model) || CommonUtil.isNull(this.software.version)  ||
            CommonUtil.isNull(this.software.issueDate) || CommonUtil.isNull(this.software.canDemo) ){
          this.$message({ type: "warning", message: this.$i18n.t('msg.incompleteInfo'), duration: 1000});
          return;
        }
        mainType = this.software.model; 
        version = this.software.version;    
        
        date2 = this.software.issueDate;
        canDemo = this.software.canDemo;
        this.software.model = ''; 
        this.software.version = ''; 

        this.software.issueDate = ''; 
        this.software.canDemo = ''; 

      } else if(type == this.productTypeOpts[3] ){
        if((CommonUtil.isNull(this.semi.custType) && CommonUtil.isNull(this.semi.incxType)) || CommonUtil.isNull(this.semi.glassId)){
          this.$message({ type: "warning", message: this.$i18n.t('msg.incompleteInfo'), duration: 1000});
          return;
        }else if(!CommonUtil.isNull(this.semi.custType) && !CommonUtil.isNull(this.semi.incxType)){ 
          this.$message({ type: "warning", message: this.$i18n.t('msg.productTypeSemiOnlyChooseOne'), duration: 1000});
          return;
        }
        if(CommonUtil.isNull(this.semi.custType)){
          mainType = this.semi.incxType; 
        }else{
          mainType = this.semi.custType; 
        }
       
        sn = this.semi.glassId;     
        //date1 = this.semi.deliveryDate;
        this.semi.custType = ''; 
        this.semi.incxType = ''; 
        this.semi.glassId = ''; 
        this.semi.deliveryDate = ''; 
        this.semi.custTypeOpts=[];
        this.semi.incxTypeOpts=[];

      } 
      let j = {
        productType: type,
        mainType: mainType,
        sn: sn,
        version: version,
        date1: CommonUtil.isNull(date1) ? '' : CommonUtil.dateFormatDate(date1),
        date2: CommonUtil.isNull(date2) ? '' : CommonUtil.dateFormatDate(date2),
        canDemo:canDemo!=null && canDemo !='' ?canDemo:'',
        action:'A',
        id:''
      };
      this.productTypeTable.data.splice(0, 0, j);
      this.currentIndex = 0;
      this.productType = '';

    },
    changeDetectorSn(){
   
      if(this.detector.sn != null && this.detector.sn != ''){
        this.detector.snOriOpts.forEach((item, index) => {   
          if(this.detector.sn == item.serialNo){
            this.detector.installDate = item.installDate;
            return;
          }
          
        });
      }
    },
    changeAccessorySn(){
   
      if(this.accessory.sn != null && this.accessory.sn != ''){
        this.accessory.snOriOpts.forEach((item, index) => {   
          if(this.accessory.sn == item.serialNo){
            this.accessory.installDate = item.installDate;
            return;
          }
          
        });
      }
    },

  }
};
</script>
<style>

.selectStyle{
  padding-right: 30px;
  width: 70%
}


</style>